<template>
    <div>
        <div v-if="loading" class="text-center">
            <v-progress-circular :size="100" color="#f87979" indeterminate></v-progress-circular>
        </div>
        <div v-else>
            <div class="text-center mb-4">
                <h2>Conversations Per Day</h2>
            </div>
            <div>
                <Bar :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId"
                    :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles"
                    :width="width" :height="height" />
            </div>
            <div>
                <v-pagination v-if="showPagination" class="py-5 mt-5" v-model="page" :length="totalPages"
                    :total-visible="7"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { removeObjectKeys } from '../../services/util';
import { mapActions } from "vuex";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'ConversationsPerDay',
    components: {
        Bar
    },
    watch: {
        page: {
            handler(value) {
                this._getConversationsPerDay({ $limit: 10, $skip: (value - 1) * 10 })
            },
        },
        filterWhere: {
            deep: true,
            handler(value) {
                this.filters.$where = value
                this.filters.$where = removeObjectKeys(this.filters.$where, 'group_name')
                this._getConversationsPerDay()
            },
        },
    },
    created() {
        this._getConversationsPerDay()
    },
    props: {
        filterWhere: {
            type: Object,
            default: () => { }
        },
        chartId: {
            type: String,
            default: 'bar-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: 'text-center mb-10',
            type: String
        },
        styles: {
            type: Object,
            default: () => { }
        },
        plugins: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            defaultSorting: { $order: { date: "$desc" } },
            filters: { $where: {} },
            loading: false,
            showModal: false,
            page: 1,
            showPagination: false,
            totalPages: 0,
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Conversations Per Day',
                        backgroundColor: '#f87979',
                        data: [],
                        barThickness: 20,
                        base: 0,
                        barStart: 0,
                        barEnd: 100
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            },
        }
    },

    methods: {
        _getConversationsPerDay(params = { $limit: 10, $skip: 0 }) {
            this.loading = true
            params = { ...params, ...this.defaultSorting, ...this.filters }
            this.getConversationsPerDay(params).then((res) => {
                let meta = res.meta
                if (meta.count > 10) this.showPagination = true
                res = res.records
                let dates = res.map(x => x.date)
                let conversations = res.map(x => x.count)

                this.totalPages = Math.ceil(meta.count / meta.limit);
                this.chartData.labels = dates
                this.chartData.datasets[0].data = conversations
                this.loading = false

            }).catch(() => this.loading = false)

        },
        ...mapActions(["getConversationsPerDay"]),
    }
}
</script>
